import type { Ref, TextareaHTMLAttributes } from "react";
import { cn } from "../lib/cn";
import { fieldShell } from "../lib/variants";
import { useField } from "./field";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & { ref?: Ref<HTMLTextAreaElement>; invalid?: boolean };

/** Автовысота по содержимому (field-sizing), min 3 строки. */
export function Textarea({ className, invalid, disabled, id, rows = 3, ...props }: TextareaProps) {
  const field = useField();
  const isInvalid = invalid ?? field?.invalid ?? false;
  const isDisabled = disabled ?? field?.disabled;
  return (
    <div data-invalid={isInvalid} data-disabled={!!isDisabled} className={cn(fieldShell, "rounded-[24px]")}>
      <textarea
        id={id ?? field?.id}
        rows={rows}
        disabled={isDisabled}
        aria-invalid={isInvalid || undefined}
        aria-describedby={field?.describedBy}
        className={cn("max-h-72 min-h-36 w-full resize-y bg-transparent px-4 py-3 text-base outline-none [field-sizing:content] placeholder:text-placeholder", className)}
        {...props}
      />
    </div>
  );
}
